import React, { useState } from 'react';
import { Modal, ModalProps } from 'semantic-ui-react';
import Button from '../elements/Button';
import Uploader from './Uploader';

const UploaderModal = ({ open, trigger, onOpen, onClose, onTriggerUpload, title = 'Upload Files', uploadButtonText = 'Upload' }: UploaderModalProps) => {
	/// Local State
	const [ filesToUpload, setFilesToUpload ] = useState<File[]>([]);

	/// Events
	const handleUploadClick = (e, props) => {
		if (onClose !== undefined && onClose !== null)
			onClose(e, props);

		if (onTriggerUpload !== undefined && onClose !== null) {
			onTriggerUpload(filesToUpload);
			setFilesToUpload([]);
		}
	};

	const handleCancelClick = (e, props) => {
		if (onClose !== undefined && onClose !== null)
			onClose(e, props);
	};

	const handleUploaderChange = (files: File[]) => {
		setFilesToUpload(files);
	};

	/// Render
	return (
		<Modal
			onClose={onClose}
			onOpen={onOpen}
			open={open}
			trigger={trigger}
		>
			{ title && <Modal.Header>{title}</Modal.Header> }
			<Modal.Content>
				<Modal.Description>
					<Uploader onChange={handleUploaderChange} value={filesToUpload} />
				</Modal.Description>
			</Modal.Content>
			<Modal.Actions>
				<Button
					secondary
					onClick={handleUploadClick}
					style={filesToUpload.length > 0 ? undefined : {
						display: 'none'
					}}
				>
					{uploadButtonText}
				</Button>
				<Button
					basic
					borderless
					content="Cancel"
					icon="cancel"
					onClick={handleCancelClick}
				/>
			</Modal.Actions>
		</Modal>
	);
};

export interface UploaderModalProps {
	open?: boolean;
	onOpen: ((event: React.MouseEvent<HTMLElement, MouseEvent>, data: ModalProps) => void) | undefined;
	onClose: ((event: React.MouseEvent<HTMLElement, MouseEvent>, data: ModalProps) => void) | undefined;
	uploadButtonText?: string;
	trigger?: React.ReactNode;
	title?: string;
	onTriggerUpload?: (files: File[]) => any
}

export default UploaderModal;